import { render, staticRenderFns } from "./TreatmentRoomNew.vue?vue&type=template&id=199fda26&"
import script from "./TreatmentRoomNew.vue?vue&type=script&lang=js&"
export * from "./TreatmentRoomNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports